import { React, useState, useEffect } from 'react';
import { MotifIcon, MotifTooltip } from '@ey-xd/motif-react';
import { actionIcInfoOutline24px } from '@ey-xd/motif-react/assets/icons';
import {
  CardTitle,
  DataCardContainerPL,
  DataContainer,
  LabelLine1,
  LabelLine2,
  Labels,
  Separator,
  TitleContainer,
  Value,
} from '../../../../atoms/dashboard/personalDashboard.styles';
import { Recoil_Quarter_State } from '../../../../../recoil/recoil';
import { useRecoilValue } from 'recoil';
import { DATA_CARD_ONE, QUARTERLY_DETAILS } from '../../../../../constants/commonConstants';
import { processNumber } from '../../../../../util/commonUtil';

const DataCardOne = data => {
  const [forecastAccuracy, setforecastAccuracy] = useState();
  let quarterInfo = useRecoilValue(Recoil_Quarter_State);

  useEffect(async () => {
    if (!!data && data != null && data != undefined) {
      setforecastAccuracy(data.data);
    }
  }, [data]);

  return (
    !!forecastAccuracy &&
    quarterInfo != null && (
      <DataCardContainerPL>
        <TitleContainer>
          <CardTitle>{DATA_CARD_ONE.FORECAST_ACCURACY}</CardTitle>
          <MotifTooltip
            id="bottom"
            trigger={
              <MotifIcon
                src={actionIcInfoOutline24px}
                style={{ width: '16px', height: '16px', margintop: '3px' }}
              ></MotifIcon>
            }
            allowHover={true}
            allowClick={true}
            placement="bottom"
          >
            If your forecasted value matches the <br /> actual Won value for each quarter/month{' '}
            <br /> of this fiscal year, your accuracy will be <br /> 100%. However,if there is any
            variance, <br /> whether it's higher or lower, your <br /> accuracy will decrease.
          </MotifTooltip>
        </TitleContainer>
        <DataContainer>
          <Value>
            {forecastAccuracy.Quarter !== null
              ? processNumber(forecastAccuracy.Quarter) + '%'
              : QUARTERLY_DETAILS.TBD}
          </Value>
          <Labels>
            <LabelLine1>{DATA_CARD_ONE.QUARTERLY}</LabelLine1>
            <LabelLine2>
              {DATA_CARD_ONE.LABLE} {quarterInfo.fiscal_year}
            </LabelLine2>
          </Labels>
        </DataContainer>
        <Separator />
        <DataContainer>
          <Value>
            {forecastAccuracy.Month !== null
              ? processNumber(forecastAccuracy.Month) + '%'
              : QUARTERLY_DETAILS.TBD}
          </Value>
          <Labels>
            <LabelLine1>{DATA_CARD_ONE.MONTHLY}</LabelLine1>
            <LabelLine2>
              {DATA_CARD_ONE.LABLE} {quarterInfo.fiscal_year}
            </LabelLine2>
          </Labels>
        </DataContainer>
      </DataCardContainerPL>
    )
  );
};

export default DataCardOne;
